import { useTranslationX } from 'i18n';
import { useAppContext } from 'context';
import { Button } from 'components/ui';
import { gtag } from 'utils';

const SignInButton = () => {
  const { auth, setOverlay } = useAppContext();
  const { tx } = useTranslationX('play.auth');

  return auth.status === 'loggedIn' ? (
    <Button
      onClick={() => {
        if (auth.validation) {
          gtag('event', 'sign_out_cliked');
          auth.setToken(null);
        } else {
          gtag('event', 'sign_in_cliked');
          setOverlay({ type: 'signin' });
        }
      }}
      type={auth.validation ? 'danger' : 'safe'}
    >
      {tx(auth.validation ? 'signout' : 'signin')}
    </Button>
  ) : null;
};

export default SignInButton;
